<div class="erro" *ngIf="validate.hasErrorValidate(control, 'required')">Campo Obrigatório</div>
<div class="erro" *ngIf="validate.hasErrorValidate(control, 'email')">Digite um email válido</div>